import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import advertDetailContactGroupCss from '../../assets/contacts/contact-group.module.scss';
import advertDetailContactItemCss from '../../assets/contacts/contact-item.module.scss';
import { ContactsPhoneLink } from '#advertDetail/components';
import { AppSvgSpriteMonoIcon } from '#src/svg';

const ContactsPhone: FC = () => {
  const {
    advert: {
      contactData,
    },
  } = useAdvertDetailContext();

  if (!('phone' in contactData)) {
    return null;
  }

  return (
    <div className={advertDetailContactGroupCss.advertDetailContactGroup}>
      <div className={advertDetailContactGroupCss.advertDetailContactGroup__header}>
        <FormattedMessage defaultMessage="Phone number:" />
      </div>
      <div className={advertDetailContactGroupCss.advertDetailContactGroup__value}>
        <div className={advertDetailContactItemCss.advertDetailContactItem}>
          <AppSvgSpriteMonoIcon name="phone" size={20} />
          <ContactsPhoneLink />
        </div>
      </div>
    </div>
  );
};

export { ContactsPhone };
